import { IFaqs } from 'pages/faq/types';

export const mapFaqModelsToIFaqs = (
  multipleObjectParentModels: any[],
): IFaqs => {
  return {
    entries: multipleObjectParentModels.map(multipleObjectParentModel => ({
      faq_list: {
        accordion_list: multipleObjectParentModel.faqModels.map((faq: any) => ({
          item: {
            title: faq.question,
            content: faq.answer
              ? [
                  {
                    copy: {
                      copy: faq.answer,
                    },
                  },
                ]
              : [],
          },
        })),
      },
    })),
  };
};

export const mapFooterData = (contentModel: any) => {
  const copyrightText = contentModel.subTitleModels?.[0]?.subTitle || '';
  const socialLinks =
    contentModel.multipleObjectParentModels?.[0]?.navigationButtonLinkModels?.map(
      (link: any) => ({
        url: link.navigationLink,
        label: link.title,
      }),
    ) || [];

  const socialLinkUrl = {
    youtube_url: '',
    twitter_url: '',
    linkedin_url: '',
    facebook_url: '',
  };

  socialLinks.forEach((item: any) => {
    switch (item.label) {
      case 'Facebook Url':
        socialLinkUrl.facebook_url = item.url;
        break;
      case 'Linkedin Url':
        socialLinkUrl.twitter_url = item.url;
        break;
      case 'Twitter Url':
        socialLinkUrl.linkedin_url = item.url;
        break;
      case 'Youtube Url':
        socialLinkUrl.youtube_url = item.url;
        break;
    }
  });
  return {
    copyright_text: copyrightText,
    footer_text: '', // Can be modified if required
    social: socialLinkUrl,
  };
};
